var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3341 21.9946C12.2956 21.9962 12.257 21.9962 12.22 21.9977C12.2586 21.9962 12.2971 21.9962 12.3341 21.9946Z",
    fill: "#1271A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9813 21.9991C11.9967 21.9991 12.0137 21.9991 12.0291 21.9991C12.08 21.9991 12.1293 21.9991 12.1802 21.9976C12.1293 21.9976 12.08 21.9991 12.0291 21.9991C12.0137 21.9991 11.9967 21.9991 11.9813 21.9991Z",
    fill: "#1271A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0295 2C6.48993 2 2 6.47663 2 11.9998C2 17.397 6.28801 21.7937 11.6519 21.9935C11.1093 21.9735 10.5776 21.9105 10.0597 21.8075V14.1928H8.42277V11.4742H10.0581V9.84217C10.0581 7.6246 10.9814 6.30605 13.6063 6.30605H15.7904V9.02461H14.4248C13.4029 9.02461 13.335 9.40419 13.335 10.1142L13.3319 11.4742H15.8058L15.516 14.1928H13.3319V21.9166C13.0622 21.952 12.7925 21.975 12.5212 21.9889C17.8311 21.7322 22.0575 17.3585 22.0575 12.0013C22.059 6.47663 17.5691 2 12.0295 2Z",
    fill: "#1271A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8138 21.9976C11.843 21.9976 11.8723 21.9991 11.9016 21.9991C11.8723 21.9976 11.843 21.9976 11.8138 21.9976Z",
    fill: "#1271A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6631 21.9927C11.7 21.9942 11.7386 21.9957 11.7756 21.9957C11.7386 21.9942 11.7016 21.9942 11.6631 21.9927Z",
    fill: "#1271A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5101 21.9893C12.4654 21.9908 12.4192 21.9939 12.3745 21.9954C12.4192 21.9923 12.4639 21.9908 12.5101 21.9893Z",
    fill: "#1271A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.e82f8e6141bc7943ac6fc32b2668b4e7.svg";
export { ForwardRef as ReactComponent };